const EXTERNAL_URLS = {
  IMMUNEFI: 'https://immunefi.com/bounty/nftx/',
};

const BASE_URLS = {
  PROFILE: 'profile',
};

const PROFILE = {
  PROFILE: BASE_URLS.PROFILE,
  PROFILE_POSITIONS: `${BASE_URLS.PROFILE}/positions`,
};

export const URLS = {
  ...PROFILE,
  ...EXTERNAL_URLS,
};
